const INVOICE_RECIPIENT = 'adam@gisvec.eu';

export async function sendInvoiceRequest(requestData, source = 'Website') {
  const response = await fetch(`https://formsubmit.co/ajax/${INVOICE_RECIPIENT}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      ...requestData,
      _subject: `Invoice request (${source}) - ${requestData.type}`,
      _template: 'table',
      _captcha: 'false',
    }),
  });

  if (!response.ok) {
    throw new Error('Request failed');
  }

  const result = await response.json();
  if (result.success !== 'true' && result.success !== true) {
    throw new Error('Email provider rejected request');
  }

  return result;
}
